module.exports = "<app-static-selector></app-static-selector>\n<app-footer></app-footer>\n"